import { useLocalSlice as l } from "use-local-slice";
const u = ({
  initialValue: c,
  initialCaseSensitive: t,
  initialExactMatch: s
}) => l({
  slice: "search",
  initialState: {
    value: c,
    caseSensitive: t,
    exactMatch: s,
    flush: !1
  },
  reducers: {
    setValue: (e, { payload: { value: a, flush: i = !1 } }) => {
      e.value = a, e.flush = i;
    },
    setCaseSensitive: (e, { payload: { value: a } }) => {
      e.caseSensitive = a;
    },
    setExactMatch: (e, { payload: { value: a } }) => {
      e.exactMatch = a;
    },
    toggleCaseSensitive: (e) => {
      e.caseSensitive = !e.caseSensitive, e.flush = !0;
    },
    toggleExactMatch: (e) => {
      e.exactMatch = !e.exactMatch, e.flush = !0;
    }
  }
});
export {
  u as useSearchState
};
//# sourceMappingURL=useSearchState.js.map
